import styled from 'styled-components';

export const Wrapper = styled.div`
  flex: 1;
  color: #aab;
  margin-bottom: 10px;

  .mark-down {
    font-size: 18px;
  }
`;

export const Row = styled.div`
  display: flex;
  flex-direction: row;
`;

export const Column = styled.div`
  &:first-child {
    flex: 3;
    margin-right: 20px;
  }

  &:last-child {
    flex: 6;
  }
`;

export const Top = styled.div`
  margin: 0 0 20px;
`;

export const Story = styled.div`
  padding: 0 40px;
`;

export const Mark = styled.div`
  width: 650px;
  min-height: 300px;
`;

export const Tags = styled.div`
  padding: 20px 0;
  gap: 8px;
  display: flex;
  flex-direction: row;
  align-items: center;
  flex-wrap: wrap;
`;
